define([
	"dojo/_base/declare",
	"csi/table/New"
], function(declare,New) {

	return declare(New, {
		onCreatePopup: function(/*csi.view.Widget*/view) {
			// summary: set Market for SalesOrder
			this.inherited(arguments);

			view.cacheView.cacheNode(this.getParent());
			view.addFixedValue("Market", this.m_urlParent);
		}
	});
});